/**
 * Class to manage the state of the SSA flag.
 * The flag must be set before rendering the app so the correct credentials are used on the request helper.
 * @see request.ts
 */
class SsaEnabledHelperClass {
  private useSsa = false;

  // Private constructor avoids creating new instances in typescript
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   * Retrieves the singleton instance of the SsaEnabledHelperClass.
   * Ensures that only one instance of the class exists throughout the application.
   *
   * @return {SsaEnabledHelperClass} The singleton instance of the SsaEnabledHelperClass.
   */
  public static getInstance(): SsaEnabledHelperClass {
    if (!window.ssaHelper) {
      window.ssaHelper = new SsaEnabledHelperClass();
    }
    return <SsaEnabledHelperClass>window.ssaHelper;
  }

  /**
   * Indicates whether SSA (Server-Side Auth) is enabled.
   *
   * @function
   * @returns {boolean} True if SSA is enabled; otherwise, false.
   */
  isSsaEnabled = () => this.useSsa;

  /**
   * Toggles the SSA (Server-Side Auth) feature on or off.
   *
   * @param {boolean} value - A boolean value indicating whether to enable (true) or disable (false) the SSA feature.
   */
  setIsSsaEnabled = (value: boolean) => {
    this.useSsa = value;
  };
}

/**
 * Function to check if SSA is enabled.
 */
export const isSsaEnabled = () =>
  SsaEnabledHelperClass.getInstance().isSsaEnabled();

export default SsaEnabledHelperClass.getInstance();
